import { DAY } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
export const generateDefaultActiveShippingDaysNTimesConfig = () => {
  return Object.keys(DAY)
    .filter((key) => isNaN(Number(key)))
    .map((d) => {
      return {
        day: DAY[d],
        active: true,
        from: '00:00',
        to: '23:59',
        upToOrders: null,
        skipDefaultSelection: false,
      };
    });
};
